import { Box, Text } from "@wix/design-system";
import React from "react";
import { SECTION_EMPTY_STATE } from "../../data-hooks/data-hooks.js";
const SectionEmptyState = ({ t }) => {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      dataHook: SECTION_EMPTY_STATE,
      direction: "vertical",
      margin: "SP4",
      gap: "SP2",
      verticalAlign: "middle",
      textAlign: "center"
    },
    /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "bold" }, t("LinkSettings_Sections_Empty_Text1")),
    /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "thin" }, t("LinkSettings_Sections_Empty_Text2"))
  );
};
export {
  SectionEmptyState
};
//# sourceMappingURL=empty-state.js.map
